import React from 'react';
import Icon from '../Icon/Icon';
import Lang from '../Lang/Lang';
import {useMobileSearchActions} from '../SearchForm/MobileSearchContext';

function MobileSearchActivatorForm(props) {
  const {open} = useMobileSearchActions();

  function toggleMobileSearch(event) {
    event.preventDefault();
    event.stopPropagation();
    open();
  }

  return (
    <form name="mobile-search-activator" className={'relative w-full flex h-[35px] grow'}>
        <span className="absolute left-3 flex justify-center items-center h-full">
          <Icon name={'search-icon'} className="h-4 w-4"/>
        </span>
      <button type="button"
              className="w-full p-3 px-10 h-full flex items-center gap-3 rounded-[14px] border-grey-20 border border-solid bg-white text-left text-[14px] leading-[21px] text-grey-90 desktop:border-r-0 desktop:rounded-l-[14px] desktop:rounded-tr-none desktop:rounded-br-none"
              onClick={toggleMobileSearch}>
        {Lang.getMessage('search')}
      </button>
    </form>
  )
}

export default MobileSearchActivatorForm;